export default __webpack_public_path__ + "static/media/tennessee.40d2a722.jpg";